import isoWeek from '../isoWeek'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type measurementFunctionType = (date1: Date, date2: Date) => boolean

const secondsAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getSeconds() === date2.getSeconds()
}
const minutesAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getMinutes() === date2.getMinutes()
}
const hoursAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getHours() === date2.getHours()
}
const weekdaysAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getDay() === date2.getDay()
}
const daysAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getDate() === date2.getDate()
}
const weeksAreSame: measurementFunctionType = (date1, date2) => {
  return isoWeek(date1) === isoWeek(date2)
}
const monthsAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getMonth() === date2.getMonth()
}
const yearsAreSame: measurementFunctionType = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear()
}
const datesAreSame: measurementFunctionType = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth()
  )
}

type DateMeasurements =
  | 'second'
  | 'minute'
  | 'hour'
  | 'weekday'
  | 'day'
  | 'week'
  | 'month'
  | 'year'
  | 'date'

type isSameType = (
  date1: dateParamType,
  date2: dateParamType,
  measurement: DateMeasurements,
) => boolean

const measurementFunctions = {
  second: secondsAreSame,
  minute: minutesAreSame,
  hour: hoursAreSame,
  weekday: weekdaysAreSame,
  day: daysAreSame,
  week: weeksAreSame,
  month: monthsAreSame,
  year: yearsAreSame,
  date: datesAreSame,
}

const isSame: isSameType = (date1Prop, date2Prop, measurement) => {
  const date1 = toDate(date1Prop)
  const date2 = toDate(date2Prop)
  if (
    Object.prototype.toString.call(date1) !== '[object Date]' ||
    Object.prototype.toString.call(date2) !== '[object Date]'
  )
    throw new Error('Must pass valid dates to isSame function')

  return measurementFunctions[measurement](date1, date2)
}

export default isSame
